import {
  KursusPerson,
  Kursushold,
  KursusholdUnderviser,
} from "../../interfaces/schema";
import { getFields } from "../../util/graphqlUtil";
import { Field } from "../../util/typeUtil";

const kursusholdUnderviserFields = getFields<Field<KursusholdUnderviser, 3>>([
  "id",
  "personId",
  "opretDato",
  "opretInit",
  "person.fuldtNavn",
  "person.fornavne",
  "person.efternavn",
  "person.tlfMobilNr",
  "person.opretDato",
  "person.opretInit",
  "person.personFirma.emailArbejde",
  "person.personFirma.periode.fraDato",
  "person.personFirma.periode.tilDatoInklusiv",
  "person.personFirma.firma.navn1",
  "person.personFirma.firma.tlf",
  "person.personFirma.firma.email",
]);

const kursusPersonFields = getFields<Field<KursusPerson, 3>>([
  "deltagerStatus",
  "tilmeldDato",
  "tilmeldtRaekkefoelge",
  "prisdeltagertotal",
  "id",
  "fakturaStatus",
  "bestaaetMark",
  "person.fuldtNavn",
  "personId",
  "opretDato",
  "fakturaNr",
  "opretInit",
  "retteDato",
  "retteInit",
  "person.kundeNr",
  "person.tlfMobilNr",
  "person.fornavne",
  "person.efternavn",
  "person.emailPrivat",
  "person.personPersonart.personartNr",
  "person.personPersonart.periode.fraDato",
  "person.personPersonart.periode.tilDatoInklusiv",
  "person.personhistorikNavigation.emailArbejde",
  "person.personhistorikNavigation.tlfMobilNr",
  "person.personhistorikNavigation.emailFirma",
  "person.personFirma.emailArbejde",
  "person.personFirma.periode.fraDato",
  "person.personFirma.periode.tilDatoInklusiv",
  "person.personFirma.firma.id",
  "person.personFirma.firma.navn1",
  "person.personFirma.firma.tlf",
  "person.personFirma.firma.email",
  "person.personFirma.firma.fakturaAfsendelse",
  "overnatningstypeNavigation.navn",
  "fakturaStatusNavigation.navn",
  "kursusPersonKursusGruppe.kursusGruppeNr",
  "kursusPersonKursusGruppe.kursusGruppeNrNavigation.nr",
  "kursusPersonKursusGruppe.kursusGruppeNrNavigation.navn",
]);

export const kursusholdFields = getFields<Field<Kursushold, 1>>([
  "holdNr",
  "navn",
  "fraDato",
  "fraKlDag",
  "tilDato",
  "tilKlDag",
  "censordato",
  "varighed",
  "kursustype",
  "hotelId",
  "pris",
  "fmulinjeId",
  "antalTilmeldteFraLinje",
  "antalTilmeldte",
  "bemaerkninger",
  "fmukursusKategoriNavigation.nr",
  "fmukursusKategoriNavigation.navn",
  "hotelNavigation.fuldtNavn",
  "hotelNavigation.navn1",
  "fmulinje.nr",
  "fmulinje.navn",
  "kursustypeNavigation.navn",
]);

type KursusholdFields = keyof Kursushold;

export const KURSUS_FIELDS: Partial<Record<KursusholdFields, string>> = {
  kursusholdUnderviser: kursusholdUnderviserFields,
  kursusPerson: kursusPersonFields,
};

export const fmuProeveDeltagerInfoFields = getFields<Field<KursusPerson, 2>>([
  "eksamensdato",
  "ikkeGennemfoert",
  "bestaaetMark",
  "tilmeldtRaekkefoelge",
  "tilmeldDato",
  "opretDato",
  "retteDato",
  "opretInit",
  "retteInit",
  "deltagerStatusNavigation.navn",
  "deltagerStatusNavigation.nr",
  "fakturaStatusNavigation.navn",
  "fakturaStatusNavigation.nr",
  "overnatningstypeNavigation.navn",
  "overnatningstypeNavigation.nr",
  "hold.id",
  "hold.bemaerkninger",
  "hold.navn",
  "hold.fraDato",
  "hold.tilDato",
  "hold.hotelNavigation.navn1",
  "hold.kursustypeNavigation.navn",
  "hold.kursustypeNavigation.nr",
  "bestaaetMark",
]);
